var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showBtn)?_c('div',{staticClass:"back-top",on:{"click":_vm.backTop}},[_c('div',{staticClass:"BJ"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }